import {logoLatest, greenTick} from '@img/index.js'
import {useWalletBalance} from '@/hooks/useWallet'
import {formatPrice} from '@/utils/functions'

const formatCents = (cents) => formatPrice(cents, {decimals: 2})

const formatExpiry = (iso) => {
    if (!iso) return null
    const d = new Date(iso)
    if (Number.isNaN(d.getTime())) return null
    return d.toLocaleDateString('en-US', {month: 'short', year: 'numeric'})
}

export default function HopnCredit() {
    const {data: balance, isLoading: balanceLoading} = useWalletBalance()
    const expiryLabel = formatExpiry(balance?.composite_expiry)

    return (
        <div className="bg-(--bg-dark) text-white rounded-3xl p-4 md:p-6">
            <div className="flex items-center gap-2 mb-5 md:mb-10">
                <img src={logoLatest} alt="hopn" className="h-8 md:h-10 brightness-0 invert"/>
                <span className="font-semibold text-lg">Credit</span>
            </div>

            <span className="text-md text-white tracking-wider block mb-1">BALANCE</span>
            {balanceLoading ? (
                <div className="animate-pulse h-8 w-32 bg-white/20 rounded mb-5"/>
            ) : (
                <span className="text-3xl font-bold block mb-5">{formatCents(balance?.available_cents || 0)}</span>
            )}

            {!balanceLoading && balance?.pending_cents > 0 && (
                <span className="block text-sm text-white/70 mb-5 -mt-3">Pending {formatCents(balance.pending_cents)}</span>
            )}

            <div className="flex items-center gap-2 mb-0">
                <img src={greenTick} alt="check" className="w-5 h-5"/>
                <span className="text-md">You can use this on checkout</span>
            </div>
            {expiryLabel && (
                <div className="border-t border-(--bg-dark-grey) mt-8 pt-8 text-md">
                    Valid until {expiryLabel}
                </div>
            )}
        </div>
    )
}
